var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('pic-selector',{attrs:{"edit-name":false,"default-cat-name":_vm.$t('banner'),"single":""},model:{value:(_vm.computedValue.gallery),callback:function ($$v) {_vm.$set(_vm.computedValue, "gallery", $$v)},expression:"computedValue.gallery"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }